import { jsx as _jsx } from "react/jsx-runtime";
import Link from '../../../common/Link';
export default function SocialIcon(props) {
    return (_jsx(Link, { to: props.href, className: "hover:cursor-pointer", children: props.children }));
}
